// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__Oze8b","ranges":"BmiRanges_ranges__2jQVk"};